import styled from '../../../styles/theme';
import { GeoLocationInputStyled } from '../GeoLocationInputStyled';
import { rem } from 'polished';

export const GeoLocationInputStyledDS = styled(GeoLocationInputStyled)`
    .geolocation-title {
        font-size: ${rem('20px')};
        font-weight: normal;
    }
`;
